import React, { Component } from "react";
import MDReactComponent from "markdown-react-js";

import LazyLoadImage from "@/components/atoms/LazyLoadImage";
import tracking from "@/utils/tracking";

import "./date-card.scss";

class DateCard extends Component {
  state = { visible: false };

  onBookClick = url => {
    tracking.event("customEvent", {
      eventCategory: "Nav Link",
      eventAction: "click",
      eventLabel: `link: Book, source: ${window.location.pathname}`
    });

    window.location.href = url;
  };

  render() {

    return (
      <div
        className={`date-card ${this.state.visible && this.props.isActive ? "date-card--active" : ""}`}
        ref={el => {
          if (!this.state.lazyItemRef && el) {
            this.setState({ lazyItemRef: el });
          }
        }}
      >
        <div
          className={`date-card__container date-card__container--${
            this.props.color
          }`}
        >
          <div className="date-card__image-container">
            {this.props.img && (
              <LazyLoadImage
                background
                src={this.props.img}
                lazyCallback={() => {
                  this.setState({ visible: true });
                }}
              />
            )}
          </div>
          <div className="date-card__text-container">
            <div className="date-card__date-container">
              <span className="date-card__date">
                <MDReactComponent text={this.props.date} />
              </span>
            </div>

            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default DateCard;



// WEBPACK FOOTER //
// ./src/components/atoms/DateCard/index.js